var convert = require('./convert'),
    func = convert('padStart', require('../padStart'));

func.placeholder = require('./placeholder');
module.exports = func;
